import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import eyeIcon from './../../img/eye.svg';
import eyeSlashIcon from './../../img/eye-slash.svg';
import checkCircleDisable from './../../img/check-circle-disable.svg';
import checkCircleSuccess from './../../img/check-circle-success.svg';
import checkCircleError from './../../img/check-circle-error.svg';
import { request } from '../../../../config';
import { translate } from 'react-i18next';
import InputMask from 'react-input-mask';
import userIconForm from "./../../../Registration/img/user-icon-form.svg";
import OtpModal from '../../../../copms/Modal/OtpModal';

class ChangeKeyword extends Component {
    state = {
        divVisibility: {
            div1: true,
            div2: true,
            // div3: false,
            // div4: true,
        },
        buttonVisibility: false,
        deviceVisibility: false,
        prevKeyword: "",
        newKeyword: "",
        newKeywordRepeat: "",

        symbolLength: null,
        letterSymbol: null,
        numericSymbol: null,
        successMessage: null,
        feedbackMessage: null,
        isRepeatKeywordSame: false,
        isPrevKeywordNotEmpty: false,
        isPrevKeywordVisibility: false,
        isNewKeywordVisibility: false,
        isNewKeywordRepeatVisibility: false,

        prevKeywordOutline: false,
        newKeywordOutline: false,
        newKeywordRepeatOutline: false,
        mobile: "",
        mobileOutline: false,
        validateMobile: false,
        openModal: false
    }
    // handleInputClick = (divName) => {

    //     const { divVisibility, div1 } = this.state;

    //     // Create a new object by setting the visibility of all divs to false, except the clicked one
    //     const updatedVisibility = Object.keys(divVisibility).reduce((acc, key) => {
    //         acc[key] = key === divName;
    //         return acc;
    //     }, {});
    //     (divName == 'div1') ?
    //         this.setState({ divVisibility: updatedVisibility, buttonVisibility: true })
    //         : this.setState({ divVisibility: updatedVisibility, deviceVisibility: true })

    // };
    handleButtonClick = () => {
        this.props.history.push('/dashboard/settings/general');
    };
    checkPrevKeywordNotEmpty = (event) => {
        this.setState({ successMessage: null, feedbackMessage: null })
        if (event.target.value.trim().length > 0) {
            this.setState({ isPrevKeywordNotEmpty: true, prevKeywordOutline: false });
        }
        else {
            this.setState({ isPrevKeywordNotEmpty: false, prevKeywordOutline: true });
        }
        this.setState({ prevKeyword: event.target.value });
    }

    checkValidationNewKeyword = (event) => {
        this.setState({ newKeyword: event.target.value });
        this.setState({ successMessage: null, feedbackMessage: null });
        if (event.target.value.length > 3 && event.target.value.length < 9) {
            this.setState({ symbolLength: true, newKeywordOutline: false });
        }
        else {
            if (event.target.value.length > 0) {
                this.setState({ symbolLength: false, newKeywordOutline: true });
            }
            else {
                this.setState({ symbolLength: null, newKeywordOutline: false });
            }
        }
        if (this.state.newKeywordRepeat === event.target.value) {
            this.setState({ isRepeatKeywordSame: true });
        }
        else {
            this.setState({ isRepeatKeywordSame: false });
        }
    }

    checkRepeatKeywordSame = (event) => {
        this.setState({ newKeywordRepeat: event.target.value });
        this.setState({ successMessage: null, feedbackMessage: null })
        if (event.target.value === this.state.newKeyword) {
            this.setState({ isRepeatKeywordSame: true, newKeywordRepeatOutline: false });
        }
        else {
            this.setState({ isRepeatKeywordSame: false, newKeywordRepeatOutline: true });
        }
    }

    setKeywordVisibility = (name) => {
        this.setState({ [name]: !this.state[name] });
    }

    getMobile = (mobile) => {
        ['+', '-', '(', ')', ' '].forEach(char => {
            while (mobile.indexOf(char) !== -1) {
                mobile = mobile.slice(0, mobile.indexOf(char)) + mobile.slice(mobile.indexOf(char) + 1, mobile.length);
            }
        });
        return mobile;
    }

    changeKeyword = (val) => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let customerType = localStorage.getItem('compId') === null ? 'Individual' : 'Juridical';
        let changeKeywordRequestBody = {
            custInfoType: "SECRET_WORD",
            // custId: localStorage.getItem('custId'),
            token: localStorage.getItem('token'),
            // secretWord: localStorage.getItem('secretWord'),
            oldSecretWord: this.state.prevKeyword,
            newSecretWord: this.state.newKeyword,
            confirmNewSecretWord: this.state.newKeywordRepeat,
            mobile: this.getMobile(this.state.mobile),
            lang: localStorage.getItem('i18nextLng').toUpperCase()
        }
        if (val !== undefined) {
            changeKeywordRequestBody.confirmCode = val;
            changeKeywordRequestBody.verifyToken = this.state.verifyToken;
        }
        fetch(request("setting/updateCustomerInfo" + customerType + "V2", changeKeywordRequestBody))
            .then(res => res.json())
            .then(changeKeywordResponse => {
                if (changeKeywordResponse.status.statusCode !== 1) {
                    if (changeKeywordResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(changeKeywordResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                else {
                    if (val === undefined) {
                        // Send OTP successful, open modal for verification
                        this.setState({ verifyToken: changeKeywordResponse.verifyToken, openModal: true });
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    } else {
                        // OTP verification successful
                        this.props.alertState(true, 'success', this.props.t('successful operation'), this.props.t('information changed successfully'));
                        // this.setState({ successMessage: this.props.t(changeKeywordResponse.status.statusCode), openModal: false });
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                        this.props.history.push("/dashboard/settings/general");
                    }
                }
            }, (error) => {
                this.props.history.push("/technical-break");
            });
    }
    setPrevKeywordOutline = () => {
        if (this.state.isPrevKeywordNotEmpty) {
            this.setState({ prevKeywordOutline: false });
        }
        else {
            this.setState({ prevKeywordOutline: true });
        }
    }
    setNewKeywordOutline = () => {
        if (this.state.symbolLength === true) {
            this.setState({ newKeywordOutline: false });
        }
        else {
            this.setState({ newKeywordOutline: true });
        }
    }
    setNewKeywordRepeatOutline = () => {
        if (this.state.isRepeatKeywordSame) {
            this.setState({ newKeywordRepeatOutline: false });
        }
        else {
            this.setState({ newKeywordRepeatOutline: true });
        }
    }
    handleMobileChange = (value) => {
        this.setState({ mobile: value, mobileOutline: true }, () => {
            setTimeout(() => {
                const valid = value.indexOf("_") === -1;
                this.setState({ validateMobile: valid }, this.updateDisabledState);
            }, 1);
        });
    }
    // prevKeywordOutline: false,
    // newKeywordOutline: false,
    // newKeywordRepeatOutline: false,
    componentDidMount() {
        this.props.updateSettingsState('settingsTitle', this.props.t('edit keyword'));
        this.props.updateSettingsState('feedback', this.props.t('edit keyword info'));

    }

    render() {
        let { divVisibility, buttonVisibility, deviceVisibility, prevKeyword, numericSymbol, letterSymbol, symbolLength,
            successMessage, feedbackMessage, isPrevKeywordVisibility, isNewKeywordVisibility, isNewKeywordRepeatVisibility,
            isRepeatKeywordSame, isPrevKeywordNotEmpty, prevKeywordOutline, newKeywordOutline, newKeywordRepeatOutline, newKeyword,
            newKeywordRepeat, validateMobile, mobileOutline, openModal } = this.state;
        let isDisabled;
        let { t } = this.props;
        if (symbolLength === false || symbolLength === null || isRepeatKeywordSame === false || isPrevKeywordNotEmpty === false || prevKeyword == newKeyword || !validateMobile) {
            isDisabled = true;
        }
        else {
            isDisabled = false;
            newKeywordOutline = false
        }
        return (
            <>
                <OtpModal open={openModal} sendConsentOtp={() => this.changeKeyword()} signSubmit={(val) => this.changeKeyword(val)} onClose={() => this.setState({ openModal: false })} />
                <div className="dashboard-settings-section-form">
                    <div className="dashboard-settings-section-password">
                        <div className="dashboard-settings-section-password-change-section">
                            {/* <div className="dashboard-settings-section-form-group" style={{ display: divVisibility.div1 ? 'block' : 'none' }}>
                                <label className="dashboard-settings-section-form-group-label">{t('password')}</label>
                                <div className={"dashboard-settings-section-form-group-box " + (prevKeywordOutline ? "input-outline" : "")}>
                                    <input type={isPrevKeywordVisibility === false ? "password" : "text"} className="dashboard-settings-section-form-group-box-input" placeholder={t('enter the old password')} onChange={this.checkPrevKeywordNotEmpty} onBlur={this.setPrevKeywordOutline} onClick={() => this.handleInputClick('div1')} />
                                    <div className="dashboard-settings-section-form-group-box-icon" onClick={this.setKeywordVisibility.bind(this, 'isPrevKeywordVisibility')} >
                                        {
                                            isPrevKeywordVisibility === false ?
                                                <img src={eyeIcon} className="dashboard-settings-section-form-group-box-icon-img dashboard-settings-section-form-group-box-icon-img__password" alt="" />
                                                :
                                                <img src={eyeSlashIcon} className="dashboard-settings-section-form-group-box-icon-img dashboard-settings-section-form-group-box-icon-img__password-slash" alt="" />
                                        }
                                    </div>
                                </div>
                            </div> */}
                            <div className="dashboard-settings-section-form-group" >
                                <label className="dashboard-settings-section-form-group-label">{t('old keyword')}</label>
                                <div className={"dashboard-settings-section-form-group-box " + (prevKeywordOutline ? "input-outline" : "")}>
                                    <input type={isPrevKeywordVisibility === false ? "password" : "text"} className="dashboard-settings-section-form-group-box-input default" placeholder={t('enter the old keyword')} onChange={this.checkPrevKeywordNotEmpty} onBlur={this.setPrevKeywordOutline} />
                                    <div className="dashboard-settings-section-form-group-box-icon" onClick={this.setKeywordVisibility.bind(this, 'isPrevKeywordVisibility')} >
                                        {
                                            isPrevKeywordVisibility === false ?
                                                <img src={eyeSlashIcon} className="dashboard-settings-section-form-group-box-icon-img dashboard-settings-section-form-group-box-icon-img__password-slash" alt="" />
                                                :
                                                <img src={eyeIcon} className="dashboard-settings-section-form-group-box-icon-img dashboard-settings-section-form-group-box-icon-img__password" alt="" />
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="dashboard-settings-section-form-group">
                                <label className="dashboard-settings-section-form-group-label">{t('new keyword')}</label>
                                <div className={"dashboard-settings-section-form-group-box " + (!newKeywordOutline ? "" : !(numericSymbol && letterSymbol && symbolLength) ? "input-outline" : "")}>
                                    <input type={isNewKeywordVisibility === false ? "password" : "text"} className="dashboard-settings-section-form-group-box-input default" placeholder={t('enter the new keyword')} onChange={this.checkValidationNewKeyword} onBlur={this.setNewKeywordOutline} />
                                    <div className="dashboard-settings-section-form-group-box-icon" onClick={this.setKeywordVisibility.bind(this, 'isNewKeywordVisibility')}>
                                        {
                                            isNewKeywordVisibility === false ?
                                                <img src={eyeSlashIcon} className="dashboard-settings-section-form-group-box-icon-img dashboard-settings-section-form-group-box-icon-img__password-slash" alt="" />
                                                :
                                                <img src={eyeIcon} className="dashboard-settings-section-form-group-box-icon-img dashboard-settings-section-form-group-box-icon-img__password" alt="" />

                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="dashboard-settings-section-form-group">
                                <label className="dashboard-settings-section-form-group-label">{t('repeat the new keyword')}</label>
                                <div className={"dashboard-settings-section-form-group-box " + (!newKeywordRepeatOutline ? "" : !isRepeatKeywordSame ? "input-outline" : "")}>
                                    <input type={isNewKeywordRepeatVisibility === false ? "password" : "text"} className="dashboard-settings-section-form-group-box-input default" placeholder={t('re-enter the new keyword')} onChange={this.checkRepeatKeywordSame} onBlur={this.setNewKeywordRepeatOutline} />
                                    <div className="dashboard-settings-section-form-group-box-icon" onClick={this.setKeywordVisibility.bind(this, 'isNewKeywordRepeatVisibility')}>
                                        {
                                            isNewKeywordRepeatVisibility === false ?
                                                <img src={eyeSlashIcon} className="dashboard-settings-section-form-group-box-icon-img dashboard-settings-section-form-group-box-icon-img__password-slash" alt="" />
                                                :
                                                <img src={eyeIcon} className="dashboard-settings-section-form-group-box-icon-img dashboard-settings-section-form-group-box-icon-img__password" alt="" />

                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="dashboard-settings-section-form-group">
                                <label className="dashboard-settings-section-form-group-label">{t('phone number')}</label>
                                <div className={"dashboard-settings-section-form-group-box " + (!mobileOutline ? "" : !validateMobile ? "input-outline" : "")}>
                                    <InputMask mask="+\9\9\4 ( 99 ) 999-99-99" className="dashboard-settings-section-form-group-box-input default" value={this.getMobile(this.state.mobile)} placeholder="+994 (__) ___-__-__" onChange={(e) => this.handleMobileChange(e.target.value)} />
                                    <div className="dashboard-settings-section-form-group-box-icon">
                                        <img src={userIconForm} className="dashboard-settings-section-form-group-box-icon-img dashboard-settings-section-form-group-box-icon-img__user" alt="" />

                                    </div>
                                </div>
                            </div>
                            {/* <div className="dashboard-settings-section-general-form-container">
                            <div className="dashboard-settings-section-general-form-group">
                                <div className="dashboard-settings-section-general-form-group-feedback">
                                    <p className="dashboard-settings-section-general-form-group-feedback-message dashboard-settings-section-general-form-group-feedback-message__info" style={{ position: 'static', height: 'auto' }}>{t('If you change the password, an information message will be sent to your mobile number.')}</p>
                                </div>
                            </div>
                        </div> */}
                        </div>
                        {/* <div className="dashboard-settings-section-password-detail-section">
                        <div className="dashboard-settings-section-password-detail-section-item">
                            {
                                (symbolLength === null) ? <img src={checkCircleDisable} className="dashboard-settings-section-password-detail-section-icon" alt="" /> : null
                            }
                            {
                                (symbolLength === false) ? <img src={checkCircleError} className="dashboard-settings-section-password-detail-section-icon" alt="" /> : null
                            }
                            {
                                (symbolLength === true) ? <img src={checkCircleSuccess} className="dashboard-settings-section-password-detail-section-icon" alt="" /> : null
                            }
                            <span className="dashboard-settings-section-password-detail-section-content">{t('must be at least 6 characters long')}</span>
                        </div>
                        <div className="dashboard-settings-section-password-detail-section-item">
                            {
                                (letterSymbol === null) ? <img src={checkCircleDisable} className="dashboard-settings-section-password-detail-section-icon" alt="" /> : null
                            }
                            {
                                (letterSymbol === false) ? <img src={checkCircleError} className="dashboard-settings-section-password-detail-section-icon" alt="" /> : null
                            }
                            {
                                (letterSymbol === true) ? <img src={checkCircleSuccess} className="dashboard-settings-section-password-detail-section-icon" alt="" /> : null
                            }
                            <span className="dashboard-settings-section-password-detail-section-content">{t('must be at least one letter')}</span>
                        </div>
                        <div className="dashboard-settings-section-password-detail-section-item">
                            {
                                (numericSymbol === null) ? <img src={checkCircleDisable} className="dashboard-settings-section-password-detail-section-icon" alt="" /> : null
                            }
                            {
                                (numericSymbol === false) ? <img src={checkCircleError} className="dashboard-settings-section-password-detail-section-icon" alt="" /> : null
                            }
                            {
                                (numericSymbol === true) ? <img src={checkCircleSuccess} className="dashboard-settings-section-password-detail-section-icon" alt="" /> : null
                            }
                            <span className="dashboard-settings-section-password-detail-section-content">{t('must be at least one digit')}</span>
                        </div>
                    </div> */}
                    </div>
                    <div className="dashboard-settings-section-form-button-section">
                        <button className="dashboard-settings-section-form-button dashboard-settings-section-form-button__save" disabled={isDisabled} onClick={() => this.changeKeyword()} >{t('save')}</button>
                        <button className="dashboard-settings-section-form-button dashboard-settings-section-form-button__cancel" onClick={this.handleButtonClick}>{t('refusal')}</button>
                    </div>
                </div>
            </>
        )
    }
}

export default translate("translation")(ChangeKeyword);